// import { LoginIcon } from "@/app/icons/icon-login";
// import { RegisterIcon } from "@/app/icons/icon-register";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import { Button, buttonVariants } from "@/components/ui/button";
import { DotsVerticalIcon } from "@radix-ui/react-icons";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import {
  BadgeCheck,
  Bell,
  LogIn as LoginIcon,
  LogOut,
  UserRoundPlus as RegisterIcon,
} from "lucide-react";
import { AppUserDetails } from "../app-user-details";
import { useQuran } from "@/app/providers/QuranContextProvider";
import { ThreeDotsIcon } from "@/app/icons/icon-three-dots";
import { logOut } from "@/auth/actions";
import { toast } from "@/lib/hooks/use-toast";
import Link from "next/link";

const UserInfo = () => {
  const { isLoggedIn, loggedInUser, setLoggedInUser, setIsLoggedIn } =
    useQuran();

  return isLoggedIn ? (
    <div className=" flex flex-row justify-center items-center border-0 w-full pt-1 pb-1">
      <div className="flex flex-row w-full relative">
        <div className="flex items-center flex-wrap w-full relative p-4 rounded-lg">
          <Avatar className="h-12 w-12 sm:h-12 sm:w-12 rounded-lg hover:bg-primary/10">
            <AvatarImage
              src={loggedInUser!!.avatar}
              alt={loggedInUser!!.name}
            />
            <AvatarFallback className="rounded-lg text-text">AV</AvatarFallback>
          </Avatar>
          <div className="grid flex-1 text-left text-sm leading-tight pl-3">
            <h1 className="text-xl font-semibold">{loggedInUser!!.name}</h1>
            <span className="text-muted-foreground text-sm">
              {loggedInUser!!.email}
            </span>
          </div>
        </div>
      </div>

      <DropdownMenu>
        <DropdownMenuTrigger
          asChild
          className="rounded-lg hover:bg-pdrimary/40"
        >
          <Button
            variant={"bgGhost"}
            className="hover:bg-primary/30"
            size={"icon"}
          >
            <ThreeDotsIcon className="ml-auto size-4" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent
          className="w-[--radix-dropdown-menu-trigger-width] min-w-56 rounded-lg p-2"
          // side={isMobile ? "bottom" : "right"}
          align="end"
          sideOffset={4}
        >
          <DropdownMenuLabel className="p-0 font-normal">
            <div className="flex items-center gap-2 px-1 py-1.5 text-left text-sm">
              <Avatar className="h-8 w-8 rounded-lg">
                <AvatarImage
                  src={loggedInUser!!.avatar}
                  alt={loggedInUser!!.name}
                />
                <AvatarFallback className="rounded-lg">CN</AvatarFallback>
              </Avatar>
              <div className="grid flex-1 text-left text-sm leading-tight">
                <span className="truncate font-semibold">
                  {loggedInUser!!.name}
                </span>
                <span className="truncate text-xs">{loggedInUser!!.email}</span>
              </div>
            </div>
          </DropdownMenuLabel>
          <DropdownMenuSeparator />
          <DropdownMenuGroup>
            <DropdownMenuItem>
              <Link href="/dashboard/settings" className="flex w-full">
                <BadgeCheck />
                <span className="pl-2">Account</span>
              </Link>
            </DropdownMenuItem>
            <DropdownMenuItem>
              <Link
                href="/dashboard/settings/notifications"
                className="flex w-full"
              >
                <Bell />
                <span className="pl-2">Notifications</span>
              </Link>
            </DropdownMenuItem>
          </DropdownMenuGroup>
          <DropdownMenuSeparator />
          <DropdownMenuItem
            onClick={async () => {
              const response = await logOut();

              setIsLoggedIn(false);

              setLoggedInUser(null);
              if (response!!.success) {
                toast({
                  title: "Logout successfull",
                  description: response.message,
                });
              } else {
                toast({
                  variant: "destructive",
                  title: "Uh oh! Something went wrong.",
                  description: response.message,
                });
              }
            }}
          >
            <div className="flex items-center">
              <LogOut />
              <span className="pl-3">Log out</span>
            </div>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  ) : (
    <>
      <div className="border-0 w-full pt-4 pb-4">
        <div className="flex flex-row w-full relative h-14">
          <div className="flex items-center flex-col justify-center w-full relative">
            <div className="w-5/6 flex flex-row justify-center">
              <Link href="/login">
                <Button className=" rounded-none rounded-l-md shadow-md">
                  <LoginIcon className="w-4 h-4" />
                  <span className="pl-2 font-bold">Login</span>
                </Button>
              </Link>
              <Link href="/signup">
                <Button
                  variant="outline"
                  className="border-1 rounded-none rounded-r-md shadow-xs"
                >
                  <RegisterIcon className="h-4 w-4" />
                  <span className="pl-2 font-regular">Signup</span>
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default UserInfo;
